export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_8-2dc926fd426de3e0933919a6c2936b3c.png";